(function ($) {


const Init = (() => {

  
  
  let website      = {},
      load         = {},
      resize       = {},
      scroll       = {},
      mod          = {},
      scrollOption = {},
      parallax     = {},
      drawer       = {},
      navi         = {},
      form         = {},
      formMethod   = {},
      timer        = {},
      wp           = {},
      iscroll      = {},
      loading      = {},
      vivus        = {},
      totop        = {},
      mmenu        = {};
  
  website = {
    page          : document.body.dataset.page,
    url           : document.URL,
    winWidth      : window.innerWidth,
    winHeight     : window.innerHeight,
    scrollY       : window.pageYOffset,
    breakpoint    : { pc: 1200, tb: 992, sp: 768, ss: 576 },
    ua            : navigator.userAgent.toLowerCase(),
    isDesktop     : true,
    isFirst       : true,
    animationFrame: null,
  
    headTag       : $('.l-header'),
  
    act           : 'is-act',
    actOpen       : 'is-open',
  
    targetAnime : 'js-anime',
    actAnime    : 'is-anime',
    shiftPoint  : 0,
    shiftPc     : 5,
    shiftSp     : 10,
  };
  website.shiftPoint = website.breakpoint.tb;
  
  load = {
    functions: [],
    length   : 0,
  };
  
  resize = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  
  scroll = {
    functions: [],
    length   : 0,
    // fps      : 60,
    isRunning: false,
    animationFrame: null,
  };
  

  let loading_data = {"v":"5.7.13","fr":30,"ip":0,"op":390,"w":1920,"h":1080,"nm":"animation","ddd":0,"assets":[{"id":"image_0","w":295,"h":84,"u":"/assets/img/common/","p":"loading_0.png","e":0},{"id":"image_1","w":175,"h":237,"u":"/assets/img/common/","p":"loading_1.png","e":0},{"id":"image_2","w":88,"h":321,"u":"/assets/img/common/","p":"loading_2.png","e":0},{"id":"image_3","w":224,"h":475,"u":"/assets/img/common/","p":"loading_3.png","e":0},{"id":"image_4","w":151,"h":59,"u":"/assets/img/common/","p":"loading_4.png","e":0},{"id":"image_5","w":154,"h":71,"u":"/assets/img/common/","p":"loading_5.png","e":0},{"id":"image_6","w":163,"h":70,"u":"/assets/img/common/","p":"loading_6.png","e":0},{"id":"image_7","w":655,"h":149,"u":"/assets/img/common/","p":"loading_7.png","e":0},{"id":"image_8","w":119,"h":169,"u":"/assets/img/common/","p":"loading_8.png","e":0},{"id":"image_9","w":128,"h":102,"u":"/assets/img/common/","p":"loading_9.png","e":0},{"id":"image_10","w":123,"h":231,"u":"/assets/img/common/","p":"loading_10.png","e":0},{"id":"image_11","w":408,"h":273,"u":"/assets/img/common/","p":"loading_11.png","e":0},{"id":"image_12","w":462,"h":158,"u":"/assets/img/common/","p":"loading_12.png","e":0},{"id":"image_13","w":1012,"h":79,"u":"/assets/img/common/","p":"loading_13.png","e":0},{"id":"image_14","w":1520,"h":379,"u":"/assets/img/common/","p":"loading_14.png","e":0},{"id":"image_15","w":1435,"h":369,"u":"/assets/img/common/","p":"loading_15.png","e":0},{"id":"comp_0","nm":"真","layers":[{"ddd":0,"ind":1,"ty":2,"nm":"真1/animation.ai","cl":"ai","refId":"image_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[333.625,82.5,0],"ix":2,"l":2},"a":{"a":0,"k":[147.5,42,0],"ix":1,"l":2},"s":{"a":0,"k":[87.433,87.433,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-23.528,-1.826],[-31.672,13.696],[-16.288,-0.913],[0,0.913]],"o":[[41.66,3.233],[34.386,-12.783],[21.718,0],[0,-0.913]],"v":[[28.731,58.435],[178.041,42.913],[240.479,28.304],[282.105,32.87]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":32.5,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":31,"s":[0]},{"t":45,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":457,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":2,"nm":"真2/animation.ai","cl":"ai","refId":"image_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[320.5,109,0],"ix":2,"l":2},"a":{"a":0,"k":[87.5,118.5,0],"ix":1,"l":2},"s":{"a":0,"k":[88.976,88.976,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-22.552,-15.378],[14.128,-20.878],[12.629,-5.427]],"o":[[22.552,15.378],[-17.139,25.328],[-12.629,5.427]],"v":[[118.17,8.141],[136.211,83.221],[8.119,230.668]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":1,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":40.8,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":50,"s":[0]},{"t":65,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":0,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":459,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"真3/animation.ai","cl":"ai","refId":"image_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[245,360,0],"ix":2,"l":2},"a":{"a":0,"k":[44,160.5,0],"ix":1,"l":2},"s":{"a":0,"k":[87.355,87.355,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-17.061,-32.644],[0,-25.39],[0,0]],"o":[[17.061,32.644],[0,74.356],[0,0]],"v":[[33.224,15.415],[61.061,125.136],[30.531,301.051]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":42.1,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":70,"s":[0]},{"t":85,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":459,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":2,"nm":"真4/animation.ai","cl":"ai","refId":"image_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[366,369,0],"ix":2,"l":2},"a":{"a":0,"k":[112,237.5,0],"ix":1,"l":2},"s":{"a":0,"k":[87.602,87.602,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-2.032,3.173],[-3.452,1.438],[-23.936,3.626],[-6.323,-0.453],[-2.258,-9.518],[2.71,-14.051],[-3.613,-38.073],[-3.161,-2.493]],"o":[[2.032,-3.173],[47.871,-19.943],[23.935,-3.626],[6.323,0.453],[2.258,9.518],[-2.71,14.051],[3.613,38.073],[3.161,2.493]],"v":[[6.774,70.253],[16.258,59.828],[117.871,19.036],[163.032,18.583],[186.065,32.18],[190.581,72.066],[168,409.733],[184.484,461.403]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":40.3,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":90,"s":[0]},{"t":105,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":460,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":2,"nm":"真5/animation.ai","cl":"ai","refId":"image_4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[318.5,281,0],"ix":2,"l":2},"a":{"a":0,"k":[75.5,29.5,0],"ix":1,"l":2},"s":{"a":0,"k":[88.214,88.214,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-9.096,2.682],[-12.28,-0.447]],"o":[[9.096,-2.682],[12.28,0.447]],"v":[[13.645,49.167],[140.994,10.727]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":27.4,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":110,"s":[0]},{"t":125,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":461,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":2,"nm":"真6/animation.ai","cl":"ai","refId":"image_5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[327.5,369.5,0],"ix":2,"l":2},"a":{"a":0,"k":[77,35.5,0],"ix":1,"l":2},"s":{"a":0,"k":[87.324,87.324,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-27.176,6.372],[-6.237,-1.149],[10.057,-3.248]],"o":[[27.177,-6.372],[54.353,10.013],[-25.365,8.192]],"v":[[19.929,36.41],[125.012,14.564],[54.353,74.641]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":24.8,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":130,"s":[0]},{"t":145,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":461,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":2,"nm":"真7/animation.ai","cl":"ai","refId":"image_6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[319,449.5,0],"ix":2,"l":2},"a":{"a":0,"k":[81.5,35,0],"ix":1,"l":2},"s":{"a":0,"k":[88.755,88.755,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-15.481,-15.133],[-27.513,7.79],[-0.226,0.224],[-13.635,-1.731],[0,0],[0,0]],"o":[[14.86,14.526],[36,-10.192],[0.226,-0.224],[15.339,1.947],[0,0],[0,0]],"v":[[10.64,40.974],[81.5,37.692],[101.854,31.372],[128.135,24.231],[148.964,45.994],[126.5,52.5]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":26.7,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":150,"s":[0]},{"t":165,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":460,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":2,"nm":"真8/animation.ai","cl":"ai","refId":"image_7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[288.5,553,0],"ix":2,"l":2},"a":{"a":0,"k":[327.5,74.5,0],"ix":1,"l":2},"s":{"a":0,"k":[87.786,87.786,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-27.655,13.344],[-79.833,8.177],[-50.803,-29.982]],"o":[[99.792,-48.152],[61.984,-6.349],[17.993,10.619]],"v":[[21.773,123.561],[314.799,33.616],[645.928,42.701]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":56.3,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":170,"s":[0]},{"t":185,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":460,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":2,"nm":"真9/animation.ai","cl":"ai","refId":"image_8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[207,623,0],"ix":2,"l":2},"a":{"a":0,"k":[59.5,84.5,0],"ix":1,"l":2},"s":{"a":0,"k":[90.533,90.533,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[14.424,-27.258],[0,0]],"o":[[-14.424,27.258],[0,0]],"v":[[108.182,11.812],[33.439,140.102]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":53.9,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":190,"s":[0]},{"t":195,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":459,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":2,"nm":"真10/animation.ai","cl":"ai","refId":"image_9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[467,652,0],"ix":2,"l":2},"a":{"a":0,"k":[64,51,0],"ix":1,"l":2},"s":{"a":0,"k":[90.196,90.196,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-36.61,-10.22],[5.408,-44.737],[0,0]],"o":[[57.69,16.105],[-34.253,-1.789],[0,0]],"v":[[18.93,6.263],[107.268,83.211],[38.761,72.474]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":31.8,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":200,"s":[0]},{"t":205,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":460,"st":0,"bm":0}]},{"id":"comp_1","nm":"心","layers":[{"ddd":0,"ind":1,"ty":2,"nm":"心1/animation.ai","cl":"ai","refId":"image_10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[55,238,0],"ix":2,"l":2},"a":{"a":0,"k":[61.5,115.5,0],"ix":1,"l":2},"s":{"a":0,"k":[85.693,85.693,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[5.591,-51.744],[-10.25,-55.44],[0,0]],"o":[[-5.591,51.744],[13.045,37.884],[0,0]],"v":[[85.727,6.468],[57.773,156.156],[94.58,219.335]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":67.5,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":210,"s":[0]},{"t":225,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":452,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":2,"nm":"心2/animation.ai","cl":"ai","refId":"image_11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379,176.5,0],"ix":2,"l":2},"a":{"a":0,"k":[204,136.5,0],"ix":1,"l":2},"s":{"a":0,"k":[85.348,85.348,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-46.364,-27.857],[-165.055,44.571],[0,0]],"o":[[105.709,87.286],[-48.218,-128.143],[0,0]],"v":[[7.418,106.786],[357.927,227.5],[261.491,8.357]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":63.5,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":230,"s":[0]},{"t":245,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":452,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"心3/animation.ai","cl":"ai","refId":"image_12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[557.25,62,0],"ix":2,"l":2},"a":{"a":0,"k":[231,79,0],"ix":1,"l":2},"s":{"a":0,"k":[85.709,85.709,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"n","pt":{"a":0,"k":{"i":[[-35.253,-46.471],[-11.133,0],[-33.398,29.741],[9.277,-31.6],[0,0]],"o":[[35.253,46.471],[11.133,0],[33.398,-29.741],[-9.277,31.6],[0,0]],"v":[[29.223,47.4],[96.018,103.165],[266.717,36.247],[424.428,99.447],[283.416,123.612]],"c":false},"ix":1},"o":{"a":0,"k":100,"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"}],"ef":[{"ty":22,"nm":"線","np":13,"mn":"ADBE Stroke","ix":1,"en":1,"ef":[{"ty":10,"nm":"パス","mn":"ADBE Stroke-0001","ix":1,"v":{"a":0,"k":1,"ix":1}},{"ty":7,"nm":"すべてのマスク","mn":"ADBE Stroke-0010","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"線(連続)","mn":"ADBE Stroke-0011","ix":3,"v":{"a":0,"k":1,"ix":3}},{"ty":2,"nm":"カラー","mn":"ADBE Stroke-0002","ix":4,"v":{"a":0,"k":[1,0,0,1],"ix":4}},{"ty":0,"nm":"ブラシのサイズ","mn":"ADBE Stroke-0003","ix":5,"v":{"a":0,"k":49.7,"ix":5}},{"ty":0,"nm":"ブラシの硬さ","mn":"ADBE Stroke-0004","ix":6,"v":{"a":0,"k":0.95,"ix":6}},{"ty":0,"nm":"不透明度","mn":"ADBE Stroke-0005","ix":7,"v":{"a":0,"k":1,"ix":7}},{"ty":0,"nm":"開始","mn":"ADBE Stroke-0008","ix":8,"v":{"a":0,"k":0,"ix":8}},{"ty":0,"nm":"終了","mn":"ADBE Stroke-0009","ix":9,"v":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":250,"s":[0]},{"t":265,"s":[100]}],"ix":9}},{"ty":7,"nm":"間隔","mn":"ADBE Stroke-0006","ix":10,"v":{"a":0,"k":15,"ix":10}},{"ty":7,"nm":"ペイントスタイル","mn":"ADBE Stroke-0007","ix":11,"v":{"a":0,"k":3,"ix":11}}]}],"ip":0,"op":452,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"真","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[560,492,0],"ix":2,"l":2},"a":{"a":0,"k":[288,349,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"w":576,"h":698,"ip":0,"op":450,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"心","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1278,514,0],"ix":2,"l":2},"a":{"a":0,"k":[378,169,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"w":756,"h":338,"ip":0,"op":450,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":2,"nm":"MAGOKORO/animation.ai","cl":"ai","refId":"image_13","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,914,0],"ix":2,"l":2},"a":{"a":0,"k":[506,39.5,0],"ix":1,"l":2},"s":{"a":0,"k":[50,50,100],"ix":6,"l":2}},"ao":0,"hasMask":true,"masksProperties":[{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[211.688,0],[-0.25,0],[-0.25,78.688],[211.688,79.188]],"c":true},"ix":1},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":270,"s":[0]},{"t":285,"s":[100]}],"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 1"},{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[481.5,-0.375],[275,-0.5],[275,80.625],[481.5,80.75]],"c":true},"ix":1},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":290,"s":[0]},{"t":305,"s":[100]}],"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 2"},{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[745.125,-0.25],[553,-0.25],[553,79.75],[745.125,79.75]],"c":true},"ix":1},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":310,"s":[0]},{"t":325,"s":[100]}],"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 3"},{"inv":false,"mode":"a","pt":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[1012.5,0.375],[816.5,0.375],[816.5,81.375],[1012.5,81.375]],"c":true},"ix":1},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":330,"s":[0]},{"t":345,"s":[100]}],"ix":3},"x":{"a":0,"k":0,"ix":4},"nm":"マスク 4"}],"ip":0,"op":390,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":2,"nm":"ロゴ/animation.ai","cl":"ai","refId":"image_14","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[0]},{"t":15,"s":[10]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2,"l":2},"a":{"a":0,"k":[760,189.5,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":390,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":2,"nm":"rogo.ai","cl":"ai","refId":"image_15","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":350,"s":[0]},{"t":365,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1688.5,976,0],"ix":2,"l":2},"a":{"a":0,"k":[717.5,184.5,0],"ix":1,"l":2},"s":{"a":0,"k":[19.634,19.634,100],"ix":6,"l":2}},"ao":0,"ip":0,"op":390,"st":0,"bm":0}],"markers":[{"tm":15,"cm":"1","dr":0},{"tm":30,"cm":"2","dr":0},{"tm":50,"cm":"3","dr":0},{"tm":70,"cm":"4","dr":0},{"tm":90,"cm":"5","dr":0},{"tm":110,"cm":"6","dr":0},{"tm":130,"cm":"7","dr":0},{"tm":150,"cm":"8","dr":0},{"tm":170,"cm":"9","dr":0},{"tm":186,"cm":"10","dr":0},{"tm":195,"cm":"11","dr":0},{"tm":210,"cm":"12","dr":0},{"tm":230,"cm":"13","dr":0},{"tm":250,"cm":"14","dr":0},{"tm":270,"cm":"15","dr":0}]}
  

  // LOAD
  const WinLoad = {
  
    init() {
      window.addEventListener('load', function(e) {
        WinLoad.update();
      });
  
      console.log('!-- load init --!');
    },
  
    add(func) {
      load.functions.push(func);
      load.length = load.functions.length;
    },
  
    remove(func) {
      load.functions.splice(func, 1);
      load.length = load.functions.length;
    },
  
    update() {
      website.contHeight = document.body.clientHeight;
      for ( let i = 0; i < load.length; i++ ) {
        let func = load.functions[i];
        func();
      }
    },
  
  }
  
  // RESIZE
  const WinResize = {
  
    init() {
      window.addEventListener('resize', function(e) {
        if ( !resize.isRunning ) {
          resize.isRunning = true;
  
          resize.animationFrame = window.requestAnimationFrame( WinResize.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinResize.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinResize.update();
          //   }, 1000/resize.fps);
          // }
        }
      });
  
      console.log('!-- resize init --!');
    },
  
    add(func) {
      resize.functions.push(func);
      resize.length = resize.functions.length;
    },
  
    remove(func) {
      resize.functions.splice(func, 1);
      resize.length = resize.functions.length;
    },
  
    update() {
      website.winWidth   = window.innerWidth;
      website.winHeight  = window.innerHeight;
      website.contHeight = document.body.clientHeight;
      website.ua         = navigator.userAgent.toLowerCase();
  
      for ( let i = 0; i < resize.length; i++ ) {
        let func = resize.functions[i];
        func();
      }
  
      resize.isRunning = false;
    },
  
  }
  
  // SCROLL
  const WinScroll = {
  
    init() {
      window.addEventListener('scroll', function(e) {
        if ( !scroll.isRunning ) {
          scroll.isRunning = true;
  
          scroll.animationFrame = window.requestAnimationFrame( WinScroll.update );
  
          // if ( window.requestAnimationFrame ) {
          //   window.requestAnimationFrame(() => {
          //     WinScroll.update();
          //   });
          // } else {
          //   setTimeout(() => {
          //     WinScroll.update();
          //   }, 1000/scroll.fps);
          // }
        }
      });
  
      console.log('!-- scroll init --!');
    },
  
    add(func) {
      scroll.functions.push(func);
      scroll.length = scroll.functions.length;
    },
  
    remove(func) {
      scroll.functions.splice(func, 1);
      scroll.length = scroll.functions.length;
    },
  
    update() {
      website.winHeight = window.innerHeight;
      website.scrollY = window.pageYOffset;
  
      for ( let i = 0; i < scroll.length; i++ ) {
        let func = scroll.functions[i];
        func();
      }
  
      scroll.isRunning = false;
    },
  
  }
  

  
  const Modules = {
  
    init() {
      mod = {
        targetSmooth    : 'js-scroll',
        targetTotop     : 'js-totop',
        smoothSpeed     : 600,
  
        targetTab       : 'js-tabWrap',
        targetTabTrigger: 'js-tabTrg',
        targetTabContent: 'js-tabCont',
  
        targetAccordion : 'js-accordion',
  
        targetModal : 'js-modal',
        targetModalOpen : 'js-modalOpen',
        targetModalClose: 'js-modalClose',
  
        targetAlign     : 'js-align',
        targetAlignList : [],
        alignAddClass   : 'c-alignheight',
  
        targetOfi       : '.js-ofi .ofi',
  
        targetMenu : 'js-menu',
        targetPagenavi : 'js-pagenavi',
  
        targetMegaWrap  : 'js-megaWrap',
        targetMegaTrg   : 'js-megaTrg',
        targetMegaCont  : 'js-megaCont',
  
        targetDateField : 'js-datepicker',
  
        targetPullTrg   : 'js-pulldown',
        targetPullConts : 'js-pulldown_conts',
  
      };
  
      let alignList = document.querySelectorAll('.' + mod.targetAlign);
      mod.targetAlignList = Array.prototype.slice.call(alignList, 0);
  
      this.iosCheck();
      this.deviceCheck();
      this.smoothScroll();
      this.tabBtn();
      this.accordionBtn();
      this.modalBtn();
      this.pulldown();
  
      objectFitImages(mod.targetOfi);
      Stickyfill.add('.js-sticky');
    },
  
    iosCheck() {
      if ( website.ua.indexOf('ipad') > -1 || website.ua.indexOf('iphone') > -1 || (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document ) ) {
        $('body').addClass('ios');
      } else {
        $('body').removeClass('ios');
      }
    },
  
    deviceCheck() {
      if (
        website.ua.indexOf('iphone') > -1 ||
        website.ua.indexOf('ipod') > -1 ||
        website.ua.indexOf('android') > -1 && website.ua.indexOf('mobile') > -1
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc tablet').addClass('sp');
      } else if (
        website.ua.indexOf('ipad') > -1 ||
        website.ua.indexOf('Android') > -1 ||
        (website.ua.indexOf('macintosh') > -1 && 'ontouchend' in document )
      ) {
        website.isDesktop = false;
        $('body').removeClass('pc sp').addClass('tablet');
      } else {
        website.isDesktop = true;
        $('body').removeClass('tablet sp').addClass('pc');
      }
    },
  
    smoothScroll() {
      $('.' + mod.targetSmooth + ':not([href=""])').on('click', function() {
        let href     = $(this).attr("href"),
            target   = $( (href == "#") ? 'html' : href ),
            position;
        if($('.'+mod.targetMenu).length){
          shift    = ( (href != "#") ) ? $('.'+mod.targetMenu).outerHeight() : 0
        }else{
          shift    = 50;
        }
        position = target.offset().top - shift;
        $('body,html').animate({scrollTop: position}, mod.smoothSpeed, 'swing');
        return false;
      });
    },
  
    tabBtn() {
      $('.' + mod.targetTabTrigger).each(function(){
        let tabBtn = $(this).children('li').children('a');
        tabBtn.on('click',function(){
          let tabHref = $(this).attr('href'),
              tabObj = $(this).parent('li').siblings('li').children('a'),
              targetCont = $(this).closest('.'+mod.targetTab).find('.'+mod.targetTabContent),
              targetObj = targetCont.find(tabHref),
              contsObj = targetObj.siblings();
              tabObj.removeClass('is-act');
              $(this).addClass('is-act');
              contsObj.hide();
              targetObj.fadeIn();
              return false;
        });
        $(this).children('li').eq(0).children('a').click();
      });
    },
  
    accordionBtn() {
      $('.' + mod.targetAccordion).on('click', function(){
        if ( $(this).hasClass(website.act) ) {
          if($(this).attr('data-target')){
            $(this).removeClass(website.act);
            $($(this).attr('data-target')).stop().slideUp('fast');
          }else{
            $(this).removeClass(website.act).next().stop().slideUp('fast');
          }
          // $(this).removeClass(website.act);
        } else {
          if($(this).attr('data-target')){
            $(this).addClass(website.act);
            $($(this).attr('data-target')).stop().slideDown();
          }else{
            $(this).addClass(website.act).next().stop().slideDown();
          }
          // $(this).addClass(website.act);
        }
      });
    },
  
    modalBtn() {
      $('.'+mod.targetModalOpen).on('click',function(){
        $('body').addClass('is-modalOpen');
        let target = $(this).attr('href');
        $(target).fadeIn();
        return false;
      });
      $('.'+mod.targetModalClose).on('click',function(){
        $('body').removeClass('is-modalOpen');
        $(this).closest('.'+mod.targetModal).fadeOut();
        return false;
      });
    },
  
    alignHeight() {
      let alignHeight  = 0;
  
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = 'auto';
        target.classList.add(mod.alignAddClass);
        alignHeight = ( target.offsetHeight > alignHeight ) ? target.offsetHeight: alignHeight;
        target.classList.remove(mod.alignAddClass);
      });
      mod.targetAlignList.forEach((target) => {
        target.style.minHeight = alignHeight + 'px';
      });
    },
  
    megaMenu (){
      if(website.winWidth >= website.shiftPoint){
        $('.'+mod.targetMegaTrg).hover(
          function(){
            let positionY = $('.'+mod.targetMegaWrap).offset().top + $('.'+mod.targetMegaWrap).height();
            $('.'+mod.targetMegaCont).css('top', positionY+'px');
            $(this).addClass('is-act');
            $(this).children('.'+mod.targetMegaCont).addClass('is-act').stop().slideDown();
          },
          function(){
            $(this).removeClass('is-act');
            $(this).children('.'+mod.targetMegaCont).removeClass('is-act').stop().slideUp();
          }
        );
      }else{
        $('.'+mod.targetMegaTrg).children('a').on('click',function(){
          $(this).parent('.'+mod.targetMegaTrg).toggleClass('is-act');
          $(this).parent('.'+mod.targetMegaTrg).find('.'+mod.targetMegaCont).toggleClass('is-act').stop().slideToggle();
        });
      }
    },
    pulldown (){
      if(website.winWidth >= website.shiftPoint){
        $('.'+ mod.targetPullTrg).hover(
          function(){
            $(this).addClass('is-act');
            $(this).children('.'+mod.targetPullConts).addClass('is-act').stop().slideDown();
          },
          function(){
            $(this).removeClass('is-act');
            $(this).children('.'+mod.targetPullConts).removeClass('is-act').stop().slideUp();
          }
        )
      } else{
        $('.'+mod.targetPullTrg).children('a').on('click',function(){
          $(this).parent('.'+mod.targetPullTrg).find('.'+mod.targetPullConts).toggleClass('is-act').stop().slideToggle();
          if(!$(this).parent('.'+mod.targetPullTrg).hasClass('is-act')){
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
            return false;
          }else{
            $(this).parent('.'+mod.targetPullTrg).toggleClass('is-act');
          }
        });
      }
    }
  }
  

  const Loading = {
    init() {
      if ($('#js-loader').length) {
        let event = new Event('animated');
        let loadingElm = document.getElementById('js-loader');
        let options = {
          container: loadingElm,
          renderer: 'svg',
          loop: false,
          autoplay: true,
          animationData: loading_data,
        };
        let loading = lottie.loadAnimation(options);
        loading.addEventListener('complete', e => {
          setTimeout(function () {
            $('#js-loader').fadeOut('fast');
            document.cookie = 'loaded=1; max-age=86400; path=/'; // 1 day in seconds
            if (document.cookie.split('; ').find(row => row.startsWith('click'))) {
              document.cookie = 'click=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
            }
            loadingElm.dispatchEvent(event);
            $('body').addClass('is-load');
          }, 1000);
        });
      }
      this.action();
    },
    actionIE() {
      if ($('#js-loaderIE').length) {
        let event = document.createEvent('Event');
        event.initEvent('animated', false, true);
        $('#js-loaderIE').addClass('is-loading');
        setTimeout(function () {
          document.cookie = 'loaded=1; max-age=86400; path=/'; // 1 day in seconds
          if (document.cookie.split('; ').find(row => row.startsWith('click'))) {
            document.cookie = 'click=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
          }
          document.getElementById('js-loaderIE').dispatchEvent(event);
          $('#js-loaderIE').addClass('is-loaded').fadeOut(400, function () {
            $('body').addClass('is-load');
          });
        }, 3000);
      }
    },
    action() {
      // $('.js-loading_trg').on('click', function () {
      //   document.cookie = 'click=1; max-age=86400; path=/'; // 1 day in seconds
      // });
    }
  }

  const DrawerMenu = {
  
    init() {
      drawer = {
        panel     : 'js-so_panel',
        menu      : 'js-so_menu',
        duration  : 10,
        // openclass : 'slideout-open',
        toggleList: '#js-so_toggle',
        closeList : '#js-so_panel, #js-so_menu .js-scroll',
      };
  
      this.menu();
    },
  
    menu() {
      let slideoutInst = new Slideout({
        'panel': document.getElementById(drawer.panel),
        'menu': document.getElementById(drawer.menu),
        'duration': drawer.duration,
        // 'openclass': drawer.openclass,
      });
  
      let nodeList = document.querySelectorAll(drawer.toggleList);
      let node = Array.prototype.slice.call(nodeList,0);
      node.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.toggle();
        });
      });
  
      let nodeListClose = document.querySelectorAll(drawer.closeList);
      let nodeClose = Array.prototype.slice.call(nodeListClose,0);
      nodeClose.forEach(function(elem, index){
        elem.addEventListener('click', function() {
          slideoutInst.close();
        });
      });
    },
  
  }
  

  const Wordpress = {
  
    init() {
      wp = {
        editorTarget: 'js-editor',
        tableClass  : 'c-tbl_responsive',
        tableInnerClass  : 'c-tbl_responsive__inner',
        iframeclass : 'c-iframe',
      }
  
      this.wpEditor();
    },
  
    wpEditor() {
      if ( document.getElementById(wp.editorTarget) != null ) {
        $( '.' + wp.editorTarget + ' table' ).each(function() {
          $(this).wrap('<div class="' + wp.tableClass + '"><div class="' + wp.tableInnerClass + '"></div></div>');
        });
        $( '.' + wp.editorTarget + ' iframe' ).each(function() {
          $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
        });
      }
      // if ( $('.' + wp.editorTarget).length ) {
      //   $( '.' + wp.editorTarget + ' table' ).each(function() {
      //     $(this).wrap('<div class="' + wp.tableClass + '"></div>');
      //   });
      //   $( '.' + wp.editorTarget + ' iframe' ).each(function() {
      //     $(this).wrap('<div class="' + wp.iframeclass + '"></div>');
      //   });
      // }
    }
  
  }
  

    const Animation = {
  
      init() {
      },
  
      check() {
        $('.' + website.targetAnime + ':not(.' + website.actAnime + ')').each(function(){
          let self = $(this),
              targetPosition = self.offset().top,
              triggerPosition,
              shift;
  
          if( website.winWidth < website.shiftPoint ) {
            shift = website.winHeight / website.shiftSp;
          } else {
            shift = website.winHeight / website.shiftPc;
          }
          triggerPosition = targetPosition - website.winHeight + shift;
  
          if( website.scrollY > triggerPosition ){
            self.addClass(website.actAnime);
          }
        });
      },
  
    }
  

  const Slick = {
  
    init() {
    },
  
    homeSlide() {
      $('.js-homeSlider').on('init',function(){
        $('.slick-current').addClass('is-anime');
      }).slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        speed: 1000,
        autoplaySpeed: 4000,
        autoplay: true,
        draggable: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        swipe: true,
      }).on({
        beforeChange: function(event, slick, currentSlide, nextSlide){
          $(".slick-slide", this).eq(currentSlide).addClass('is-prev');
          $(".slick-slide", this).eq(nextSlide).addClass('is-anime');
        },
        afterChange: function() {
          $(".is-prev", this).removeClass("is-prev is-anime");
        }
      });
    },
  
  }
  

  const Stroke = {
    init() {
      vivus = {
        type :  'oneByOne',
        start :  'manual',
        forceRender :false,
        duration : 200,
        animTimingFunction : Vivus.LINEAR,
      }
    },
    check() {
      if($('#js-vivus').length){
        let speed = $('#js-vivus').attr('data-speed');
        if(!speed){
          speed = 200;
        }
        if($('#js-vivus').closest('.js-anime').hasClass('is-anime') && !$('#js-vivus').parent().hasClass('is-anime')){
          $('#js-vivus').parent().addClass('is-anime');
          new Vivus('js-vivus', {
            type :  'sync',
            start :  'autostart',
            forceRender :false,
            duration : speed,
            animTimingFunction : Vivus.LINEAR,
          });
        }
      }
    },
  }
  

  const Totop = {
    init() {
      totop = {
        targetClass: '.js-totop',
        endpoint   : '.js-totop_ep',
        speed: 600,
      }
      this.check();
      this.action();
    },
    check() {
      let contHeight = $('body').innerHeight();
      if( website.scrollY + website.winHeight > $(totop.endpoint).offset().top){
        $(totop.targetClass).css({'position' : 'absolute', 'bottom' : 'calc('+$(totop.endpoint).innerHeight() + 'px + 2vw)'});
      }else{
        $(totop.targetClass).css({'position' : 'fixed','bottom' : ''});
      }
      if (website.scrollY > 100) {
        $(totop.targetClass).addClass('is-act').fadeIn(400);
      } else {
        $(totop.targetClass).removeClass('is-act').fadeOut(400);
      }
    },
    action() {
      $(totop.targetClass).on('click', function () {
        $('body,html').animate({ scrollTop: 0 }, totop.speed, 'swing');
        return false;
      });
    }
  }
  



  // OFF
  // ./inc/_loading.js

  // ./inc/_timer.js

  // ./inc/_pagescroll.js

  // ./inc/_parallax.js




  const TopPage = {

    init() {
      top = {};
      if($('#js-loader').length){
        $('#js-loader').on('animated',function(){
          Slick.homeSlide();
        });
      }else if($('#js-loaderIE').length){
        $('#js-loaderIE').on('animated',function(){
          Slick.homeSlide();
        });
      }else{
        Slick.homeSlide();
      }
    },

    update() {
    },

  }


  const BasicPage = {

    init() {
      basic = {};
    },

    update() {
    },

  }


  const App = {

    init() {
      if ( website.page != 'wp-manual' && website.page != 'wp-manual-single' ) {
        this.set();
        // this.update();
      } else {
        // Modules.init();
        Wordpress.init();
      }
    },

    set() {
      Loading.init();
      Modules.init();
      DrawerMenu.init();
      Wordpress.init();
      Totop.init();
      // Form.init();
      // Animation.init();
      // PageScroll.init();
      // Parallax.init();
      // Slick.init();


      if ( website.page == 'top' ) {
        TopPage.init();
      } else {
        // BasicPage.init();
      }

      WinLoad.add( Animation.check );
      WinLoad.add( Loading.actionIE );
      WinLoad.add( Stroke.init );
      // WinLoad.add( Modules.megaMenu );
      // WinLoad.add( Iscroll.check );

      WinResize.add( Modules.iosCheck );
      WinResize.add( Modules.deviceCheck );

      WinScroll.add( Animation.check );
      WinScroll.add( Totop.check );

      WinScroll.add( Stroke.check );
      // WinScroll.add( Totop.check );
      // WinScroll.add( Iscroll.check );


      WinLoad.init();
      WinResize.init();
      WinScroll.init();

    },

    // update() {
    //   website.animationFrame = window.requestAnimationFrame( App.update );
    //   website.winWidth       = window.innerWidth;
    //   website.winHeight      = window.innerHeight;
    //   website.scrollY        = window.pageYOffset;

    //   if ( website.isDesktop ) {
    //     PageScroll.smooth();

    //     if ( website.page == 'top' ) {
    //       Parallax.moveImg();
    //     }
    //   }
    // },

  }


  App.init();

})();


})(jQuery);
